import {
  UPDATE_SUBSCRIPTION_REQUEST,
  UPDATE_SUBSCRIPTION_SUCCESS,
  UPDATE_SUBSCRIPTION_ERROR,
} from '~gatsby-theme-autonomy/redux/actions/types'

export const updateSubscriptionRequest = () => ({
  type: UPDATE_SUBSCRIPTION_REQUEST,
})

export const updateSubscriptionSuccess = (data) => ({
  type: UPDATE_SUBSCRIPTION_SUCCESS,
  payload: {
    data,
  },
})

export const updateSubscriptionError = (error) => ({
  type: UPDATE_SUBSCRIPTION_ERROR,
  payload: error,
  error: true,
})

export const updateSubscription =
  (subscriptionId) =>
  (props) =>
  async (dispatch, getState, { api }) => {
    dispatch(updateSubscriptionRequest())
    try {
      const { user } = getState()
      const userId = user.data.id

      if (props.lineItems) {
        const variants = await api.getVariantsBySkus(
          props.lineItems.map((lineItem) => lineItem.sku)
        )

        props.line_items_attributes = props.lineItems.map(
          ({ sku, ...lineItem }) => ({
            id: lineItem.id,
            quantity: lineItem.quantity,
            _destroy: lineItem._destroy,
            subscribable_id: variants.find((v) => v.sku === sku)?.id,
          })
        )

        delete props.lineItems
      }

      const response = await api.updateSubscription(
        userId,
        subscriptionId,
        props
      )
      dispatch(updateSubscriptionSuccess(response))
      return response
    } catch (error) {
      dispatch(updateSubscriptionError(error))
      throw error
    }
  }
